import React from 'react';
import { RMSvgIconProps } from 'components/customComponents/CommonComponents/RMSvgIcon';
import AlertBox from './alertBox';

interface Props {
  title: string;
}

const InfoBox = (props: Props) => {
  const { title } = props;
  const infoIconProps: RMSvgIconProps = {
    id: 'infobox-icon',
    name: 'Info',
    fill: '#006AF5',
    width: '20px',
    height: '22px',
  };
  return <AlertBox title={title} iconProps={infoIconProps} backgroundColor="#aacdfc" />;
};

export default InfoBox;
